import { GetReplenishmentOrdersVm } from './get-replenishment-orders.vm';
import { CallbackObject } from 'api/core/get-page-function';
import { plainToClass } from 'class-transformer';
import { AxiosResponse } from 'axios';
import { instance } from 'api/core';
import { OrderStatus } from './replenishment-order.vm';

export const getReplenishmentOrders = async (
    offset: string,
    warehouseId: string,
    locationId?: string,
    productId?: string,
    status?: OrderStatus,
    callback?: CallbackObject<GetReplenishmentOrdersVm>
) => {
    const config: Record<string, any> = {
        headers: {
            'Content-Type': 'application/json'
        },
        params: {
            limit: 50,
            offset: offset
        },
    };

    if (locationId) {
        config.params.locationId = locationId
    }

    if (productId) {
        config.params.productId = productId
    }

    if (status) {
        config.params.status = status
    }

    try {
        const res: AxiosResponse = await instance.get(`/replenishment/warehouses/${warehouseId}/orders`, config);
        if (callback?.success) callback.success(plainToClass(GetReplenishmentOrdersVm, res.data));
    } catch (err) {
        if (callback?.error) callback.error(err);
    }
};
